<template>
    <div class="w-full border-gray-300 border rounded-lg p-2 px-4 mt-4">
        <div class="w-full mb-1 text-lg flex mt-2">
            <div class="flex-grow mb-1 text-lg">{{ typeText }} Budgets:</div>
            <ui-toggle class="inline-block w-auto p-0.5 rounded-xl" field="text-xs"
                       v-model="viewByComponent"
                       :text="`View by Component`"
                       :field="'text-gray-900'"
            ></ui-toggle>
        </div>
        <div v-if="!viewByComponent">
            <div
                class="flex mt-2 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px"
                     v-text="contextTypeText"></div>
                <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Budget</div>
                <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Budget to
                    Date
                </div>
                <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Cost to
                    Date
                </div>
                <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Variance
                </div>
            </div>
            <div class="flex border-t -mb-px border-gray-200"></div>
            <template v-if="contextType==='contract'">
                <resource-planning-report-budget
                    v-for="(section,index) in context.sections" :title="section.name"
                    inner-class="bg-gray-100 mt-2"
                    :budget="section[type+'Budget']"
                    :key="contextType+'|'+section.id">
                    <resource-planning-report-budget
                        v-for="(task,index) in section.tasks" :title="task.name"
                        inner-class="bg-gray-50"
                        :budget="task[type+'Budget']" :depth="1"
                        :key="contextType+'|'+task.id">
                        <resource-planning-report-budget
                            v-for="(item,index) in task.items"
                            inner-class="bg-white"
                            :title="item.reference+' '+item.description"
                            :budget="item[type+'Budget']" :depth="2"
                            :key="contextType+'|'+item.id">
                        </resource-planning-report-budget>
                        <div class="flex border-t -mb-px border-gray-200"></div>
                    </resource-planning-report-budget>
                    <div class="flex border-t -mb-px border-gray-200"></div>
                </resource-planning-report-budget>
            </template>
            <template v-else-if="contextType==='section'">
                <resource-planning-report-budget
                    v-for="(task,index) in context.tasks" :title="task.name"
                    inner-class="bg-gray-50 mt-2"
                    :budget="task[type+'Budget']"
                    :key="contextType+'|'+task.id">
                    <resource-planning-report-budget
                        v-for="(item,index) in task.items"
                        inner-class="bg-white"
                        :title="item.reference+' '+item.description"
                        :budget="item[type+'Budget']" :depth="1"
                        :key="contextType+'|'+item.id">
                    </resource-planning-report-budget>
                    <div class="flex border-t -mb-px border-gray-200"></div>
                </resource-planning-report-budget>
            </template>
            <template v-else-if="contextType==='task'">
                <resource-planning-report-budget
                    v-for="(item,index) in context.items"
                    inner-class="bg-white"
                    :title="item.reference+' '+item.description"
                    :budget="item[type+'Budget']"
                    :key="contextType+'|'+item.id">
                </resource-planning-report-budget>
            </template>
            <template v-else-if="contextType==='item'">
                <resource-planning-report-budget
                    inner-class="bg-white"
                    :title="context.reference+' '+context.description"
                    :budget="context[type+'Budget']" :key="contextType+'|'+contextId">
                </resource-planning-report-budget>
            </template>
            <div class="flex border-t -mb-px border-gray-200"></div>
            <div class="pb-4">
            </div>
        </div>
        <div v-else>
            <template v-if="context.components.some(i => i[type+'Budget'])">
                <div
                    class="flex mt-2 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                    <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px">Component
                    </div>
                    <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Budget</div>
                    <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Budget to
                        Date
                    </div>
                    <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Cost to
                        Date
                    </div>
                    <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Variance
                    </div>
                </div>
                <resource-planning-report-budget
                    v-for="(component,index) in context.components"
                    v-if="component[type+'Budget']"
                    :title="component.name" :budget="component[type+'Budget']"
                    :key="'component|'+contextId+'|'+index">
                </resource-planning-report-budget>
                <div class="flex border-t -mb-px border-gray-200"></div>
            </template>
            <!----- NON COMPONENTS -->
            <div v-if="hasNonComponents()" class="p-4 my-2 rounded-lg border-gray-200 border">
                <div
                    class="flex mt-0 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                    <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px">Non-Component items
                    </div>
                    <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Budget</div>
                    <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Budget to
                        Date
                    </div>
                    <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Cost to
                        Date
                    </div>
                    <div class="w-32 border-r border-gray-200 px-2 py-1 -ml-px text-right">Variance
                    </div>
                </div>
                <div class="flex border-t -mb-px border-gray-200"></div>
                <div class="flex border-t -mb-px border-gray-200"></div>
                <template v-if="contextType==='contract'">
                    <resource-planning-report-budget
                        v-for="(section,index) in context.sections" :title="section.name"
                        inner-class="bg-gray-100 mt-2"
                        :budget="budgetLessComponents(section)"
                        v-if="section.tasks.some(t => t.items.some(i => budgetLessComponents(i)))"
                        :key="contextType+'|'+section.id">
                        <resource-planning-report-budget
                            v-for="(task,index) in section.tasks" :title="task.name"
                            inner-class="bg-gray-50"
                            v-if="task.items.some(i => budgetLessComponents(i))"
                            :budget="budgetLessComponents(task)" :depth="1"
                            :key="contextType+'|'+task.id">
                            <resource-planning-report-budget
                                v-for="(item,index) in task.items"
                                inner-class="bg-white"
                                :title="item.reference+' '+item.description"
                                v-if="budgetLessComponents(item)"
                                :budget="budgetLessComponents(item)" :depth="2"
                                :key="contextType+'|'+item.id">
                            </resource-planning-report-budget>
                            <div class="flex border-t -mb-px border-gray-200"></div>
                        </resource-planning-report-budget>
                        <div class="flex border-t -mb-px border-gray-200"></div>
                    </resource-planning-report-budget>
                </template>
                <template v-else-if="contextType==='section'">
                    <resource-planning-report-budget
                        v-for="(task,index) in context.tasks" :title="task.name"
                        inner-class="bg-gray-50 mt-2"
                        :budget="budgetLessComponents(task)"
                        v-if="task.items.some(i => budgetLessComponents(i))"
                        :key="'n'+contextType+'|'+task.id">
                        <resource-planning-report-budget
                            v-for="(item,index) in task.items"
                            inner-class="bg-white"
                            :title="item.reference+' '+item.description"
                            v-if="budgetLessComponents(item)"
                            :budget="budgetLessComponents(item)" :depth="1"
                            :key="'n'+contextType+'|'+item.id">
                        </resource-planning-report-budget>
                        <div class="flex border-t -mb-px border-gray-200"></div>
                    </resource-planning-report-budget>
                </template>
                <template v-else-if="contextType==='task'">
                    <resource-planning-report-budget
                        v-for="(item,index) in context.items"
                        inner-class="bg-white"
                        :title="item.reference+' '+item.description"
                        v-if="budgetLessComponents(item)"
                        :budget="budgetLessComponents(item)"
                        :key="'n'+contextType+'|'+item.id">
                    </resource-planning-report-budget>
                </template>
                <template v-else-if="contextType==='item'">
                    <resource-planning-report-budget
                        inner-class="bg-white"
                        :title="context.reference+' '+context.description"
                        v-if="budgetLessComponents(context)"
                        :budget="budgetLessComponents(context)" :key="'n'+contextType+'|'+contextId">
                    </resource-planning-report-budget>
                </template>
                <div class="flex border-t -mb-px border-gray-200"></div>
            </div>
            <!----- NOTHING -->
            <template v-if="!hasNonComponents() &&context.components.some(i => i[type+'Budget']) ">
            </template>
        </div>
    </div>
</template>

<script>

import UiToggle from "../ui/UiToggle.vue";
import {resolveNumericText, toCurrency, uuid} from "../../utils";
import {ResourcePlanningReport} from "@models";
import ResourcePlanningReportMaterialItem from "./ResourcePlanningReportMaterialItem.vue";
import ResourcePlanningReportBudget from "./ResourcePlanningReportBudget.vue";
import UiSelectSearchable from "../ui/UiSelectSearchable.vue";
import {cloneDeep} from "lodash";

export default {
    components: {
        UiSelectSearchable,
        ResourcePlanningReportBudget,
        ResourcePlanningReportMaterialItem,
        UiToggle,
    },
    props: {
        resourcePlanningReport: null,
        type: String,
        contextCode: Object,
    },
    data() {
        return {
            resolveNumericText,
            viewByComponent: false,
        };
    },
    computed: {
        contextType() {
            return this.contextCode.value.split('|')[0]
        },
        contextTypeText() {
            return {'contract': 'Section', 'section': 'Task', 'task': 'Item', 'item': 'Item'}[this.contextType];
        },
        typeText() {
            let o = this.type[0].toUpperCase() + this.type.slice(1);
            if (o === 'FixedCost') {
                return 'Fixed Cost'
            }
            return o;
        },
        contextId() {
            return this.contextCode.value.split('|')[1]
        },
        context() {
            if (this.contextType === 'section') {
                return this.resourcePlanningReport.sections.find(section => section.id === this.contextId)
            }
            if (this.contextType === 'task') {
                for (let i = 0; i < this.resourcePlanningReport.sections.length; i++) {
                    let o = this.resourcePlanningReport.sections[i].tasks.find(task => task.id === this.contextId)
                    if (o) {
                        return o;
                    }
                }
            }
            if (this.contextType === 'item') {
                for (let i = 0; i < this.resourcePlanningReport.sections.length; i++) {
                    for (let i2 = 0; i2 < this.resourcePlanningReport.sections[i].tasks.length; i2++) {
                        let o = this.resourcePlanningReport.sections[i].tasks[i2].items.find(item => item.id === this.contextId)
                        if (o) {
                            return o;
                        }
                    }
                }
            }
            return this.resourcePlanningReport;
        }
    },
    methods: {
        budgetLessComponents(obj) {
            let budget = cloneDeep(obj[this.type + 'Budget']);
            if (!budget) {
                budget = {
                    budget: 0,
                    budgetToDate: 0,
                    costToDate: 0,
                };
            }
            obj.components.forEach(component => {
                let componentBudget = component[this.type + 'Budget'];
                budget.budget = resolveNumericText(budget ? budget.budget : 0) - (componentBudget ? resolveNumericText(componentBudget.budget) : 0);
                budget.budgetToDate = resolveNumericText(budget ? budget.budgetToDate : 0) - (componentBudget ? resolveNumericText(componentBudget.budgetToDate) : 0);
                budget.costToDate = resolveNumericText(budget ? budget.costToDate : 0) - (componentBudget ? resolveNumericText(componentBudget.costToDate) : 0);
            })
            if (budget && !budget.budget && !budget.budgetToDate && !budget.costToDate) {
                return false;
            }
            return budget;
        },
        hasNonComponents() {
            if (this.contextType === 'section') {
                return this.context.tasks.some(t => t.items.some(i => this.budgetLessComponents(i)))
            } else if (this.contextType === 'task') {
                return this.context.items.some(i => this.budgetLessComponents(i))
            } else if (this.contextType === 'item') {
                return this.budgetLessComponents(this.context)
            } else {
                return this.context.sections.some(s => s.tasks.some(t => t.items.some(i => this.budgetLessComponents(i))))
            }
        }
    },
    async mounted() {
    }
};
</script>
